import { AbstractControl, ValidationErrors } from '@angular/forms';
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';

export const phoneNumberValidator = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;
  if (!value || typeof value !== 'string' || value.trim() === '') {
    return null;
  }

  try {
    const numberInstance = parsePhoneNumberFromString(value);
    if (!numberInstance || !numberInstance.isValid()) {
      return { validatePhoneNumber: true };
    }
    return null;
  } catch {
    return { validatePhoneNumber: true };
  }
};
